export const Tooltip = {
  // style object for base or default style
  baseStyle: {
    fontSize: 'xs',
    borderRadius: '4px',
    bg: 'gray.700',
    padding: '4px 8px',
  },
};
